import API_PATH from "../../../config/API_PATH";
import {
  SHOW_POPUP_LOGIN_MINI,
  SHOW_POPUP_EARNMORE,
  SHOW_POPUP_PIECE,
  SHOW_POPUP_CHANGE_COINS_SUCCESS,
  SHOW_POPUP_GIVE_PIECE,
  MINIGAME_CONFIG,
  MINIGAME_GET_SPIN_AWARD,
  MINIGAME_GET_SPIN_USER,
  MINIGAME_AWARD_LIST,
  MINIGAME_PIECE_COLLECTED,
  MINIGAME_MISSIONS,
  MINIGAME_CHANGE_ATTEMP_BY_ID,
  MINIGAME_PRIZE_COLLECTION,
  MINIGAME_TAKE_PRIZE,
  MINIGAME_CURRENT_CYCLE_LIST_WINNER,
  MINIGAME_HISTORY,
  MINIGAME_SPIN_HISTORY,
  MINIGAME_ADD_PIECE_LINK,
  MINIGAME_CONFIRM_PIECE_LINK,
  MINI_SET_SPIN,
  MINIGAME_OPEN_POPUP_ERROR,
  MINIGAME_GET_RULE,
  SHOW_POPUP_GIVE_PIECE_SUCCESS,
  SHOW_POPUP_MISSION,
  MINIGAME_PAST_CYCLE_LIST_WINNER,
  MINIGAME_RANKING,
  SHOW_POPUP_PUZZLE,
  SHOW_POPUP_INTRO_GIFT,
} from "./contants";

export const setDataSpinLeft = (data) => {
  return {
    type: MINI_SET_SPIN,
    data,
  };
};

export const setDataPopupError = (data) => {
  return {
    type: MINIGAME_OPEN_POPUP_ERROR,
    data,
  };
};

export const getRuleMiniGame = () => {
  return {
    type: MINIGAME_GET_RULE,
    meta: {
      method: "GET",
      url: API_PATH.miniGameGetRule,
    }
  }
}

export const getConfigMiniGame = () => {
  return {
    type: MINIGAME_CONFIG,
    meta: {
      method: "GET",
      url: API_PATH.miniGameConfig,
    },
  };
};

// lấy giải thường vòng quay
export const getDataSpinAwardMiniGame = () => {
  return {
    type: MINIGAME_GET_SPIN_AWARD,
    meta: {
      method: "GET",
      url: API_PATH.miniGameGetSpinAward,
    },
  };
};

export const getDataSpinUserMiniGame = () => {
  return {
    type: MINIGAME_GET_SPIN_USER,
    meta: {
      method: "GET",
      url: API_PATH.miniGameGetSpinUser,
    },
  };
};

export const getDataAwardListMiniGame = () => {
  return {
    type: MINIGAME_AWARD_LIST,
    meta: {
      method: "GET",
      url: API_PATH.miniGameAwardList,
    },
  };
};

export const getDataPieceCollectedMiniGame = (id) => {
  return {
    type: MINIGAME_PIECE_COLLECTED,
    meta: {
      method: "GET",
      url: `${API_PATH.miniGamePieceCollected}?award_id=${id}`,
    },
  };
};

export const getDataMissionMiniGame = () => {
  return {
    type: MINIGAME_MISSIONS,
    meta: {
      method: "GET",
      url: API_PATH.miniGameMissions,
    },
  };
};

export const changeAttemptByBidMiniGame = (data) => {
  return {
    type: MINIGAME_CHANGE_ATTEMP_BY_ID,
    data,
    meta: {
      method: "POST",
      url: API_PATH.miniGameChangeAttempById,
      callback: data.callback || null,
    },
  };
};

export const getDataPrizeCollectionMiniGame = () => {
  return {
    type: MINIGAME_PRIZE_COLLECTION,
    meta: {
      method: "GET",
      url: API_PATH.miniGamePrizeCollection,
    },
  };
};

export const takePrizeMiniGame = (data) => {
  return {
    type: MINIGAME_TAKE_PRIZE,
    data,
    meta: {
      method: "POST",
      url: API_PATH.miniGameTakePrize,
      callback: data.callback || null,
    },
  };
};

export const getDataListWinnerMiniGame = (data) => {
  return {
    type: MINIGAME_CURRENT_CYCLE_LIST_WINNER,
    meta: {
      method: "GET",
      url: `${API_PATH.miniGameLisWinner}?my_winner=${
        data.my_winner || 0
      }`,
    },
  };
};

export const getDataListWinnerPastMiniGame = (data) => {
  return {
    type: MINIGAME_PAST_CYCLE_LIST_WINNER,
    meta: {
      method: "GET",
      url: `${API_PATH.miniGameLisWinner}?my_winner=${
        data.my_winner || 0
      }&minigame_id=${data.minigame_id}`,
    },
  };
}

export const getDataHistoryMiniGame = (data) => {
  return {
    type: MINIGAME_HISTORY,
    meta: {
      method: "GET",
      url: `${API_PATH.miniGameHistory}?page=${data.page}&limit=${data.limit}`,
    },
  };
};

export const getDataSpinHistoryMiniGame = (data) => {
  return {
    type: MINIGAME_SPIN_HISTORY,
    meta: {
      method: "GET",
      url: `${API_PATH.miniGameSpinHistory}?my_history=${data.my_history}&page=${data.page}&limit=${data.limit}&minigame_id=${data.minigame_id}`,
    },
  };
};

export const getDataRankingMiniGame = (data) => {
  return {
    type: MINIGAME_RANKING,
    meta: {
      method: "GET",
      url: API_PATH.miniGameRanking,
    }
  }
}

export const pieceLinkMiniGame = (data) => {
  return {
    type: MINIGAME_ADD_PIECE_LINK,
    data,
    meta: {
      method: "POST",
      url: API_PATH.miniGameAddPieceLink,
      callback: data.callback || null,
    },
  };
};

export const confirmPieceLinkMiniGame = (data) => {
  return {
    type: MINIGAME_CONFIRM_PIECE_LINK,
    data,
    meta: {
      method: "POST",
      url: API_PATH.miniGameConfirmPieceLink,
      callback: data.callback || null,
    },
  };
};

// data popup

export const setOpenPopupLogin = (data) => {
  return {
    type: SHOW_POPUP_LOGIN_MINI,
    data,
  };
};

export const setOpenPopupFooter = (data) => {
  return {
    type: SHOW_POPUP_EARNMORE,
    data,
  };
};

export const setOpenPopupIntroGift = (data) => {
  return {
    type: SHOW_POPUP_INTRO_GIFT,
    data,
  };
};

export const setOpenPopupPiece = (data) => {
  return {
    type: SHOW_POPUP_PIECE,
    data,
  };
};

export const setOpenPopupChangeCoinsSuccess = (data) => {
  return {
    type: SHOW_POPUP_CHANGE_COINS_SUCCESS,
    data,
  };
};
export const setOpenPopupGivePiece = (data) => {
  return {
    type: SHOW_POPUP_GIVE_PIECE,
    data,
  };
};

export const setOpenPopupGivePieceSuccess = (data) => {
  return {
    type: SHOW_POPUP_GIVE_PIECE_SUCCESS,
    data,
  }
}

export const setPopupMission = (data) => {
  return {
    type: SHOW_POPUP_MISSION,
    data,
  }
}

export const setOpenPopupPuzzle = (data) => {
  return {
    type: SHOW_POPUP_PUZZLE,
    data,
  }
}
